@if ((networkService.online$ | async) === false) {
  <div class="message-div offline-div" i18n="@@topbar-offline">
  No internet connection.
</div>
}
@if (userShouldUpdate) {
  <div class="message-div should-update-div" i18n="@@topbar-should-update">
  Acted Core has been updated, please refresh your window!
</div>
}

<div [class]="'min-h-screen flex relative ' + (sidebarVisible ? 'sidebar-visible' : '')">
  <!-- SIDEBAR -->
  <p-drawer id="app-sidebar-1" [(visible)]="sidebarVisible" [dismissible]="false" [modal]="false" [baseZIndex]="1" [closeOnEscape]="false">
    <ng-template #header>
      <div class="acted-logo flex flex-grow-1 align-items-center justify-content-center flex-shrink-0">
        <a [routerLink]="['/']">
          <img src="assets/icons/acted-white.svg" alt="Acted" i18n-alt="@@sidebar-logo_alt" style="height: 48px; margin-right: 8px; margin-top: 12px;" (dblclick)="gitVersionsVisible = true">
        </a>
      </div>
    </ng-template>
    <ng-template #content>
      <div class="flex flex-column h-full">
        <div class="overflow-y-auto p-3 mt-0 mx-0 mb-7 sidebar-scroller">

          <!-- LOOP OVER LEVEL 0 MENU BUTTONS -->
          @for (level0 of menuNodes; track level0) {
            <!-- IF USER HAS LEVEL 0 PERMISSION -->
            @if (userService.hasPermissionIn(level0.data.hasPermissionIn)) {
              <ul class="list-none p-0 mt-0 overflow-hidden sidebar-ul test-level0" [ngClass]="level0.data.negativeStyle ? 'negative-style' : ''">
                <li class="test-level0">
                  <!-- SIMPLE BUTTON IF NO CHILDREN -->
                  @if (!level0.children) {
                    <a pRipple
                      class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors menu-link"
                      [routerLink]="level0.data.isExternal ? null : level0.data.routerLink"
                      [queryParams]="level0.data.isExternal ? null : (level0.data.queryParams || {})"
                      (click)="level0.data.isExternal ? openExternalLink(level0.data.externalLink) : null"
                      [ngClass]="(!level0.data.isExternal && currentUrlRoot.startsWith(level0.data.currentUrlRoot)) ? 'router-link-active' : ''"
                      [id]="level0.data.id ?? ''">
                      <i [class]="'sidebar-icon fa ' + level0.data.iconClass"></i>
                      <span class="font-medium">{{level0.label}}</span>
                      @if (level0.data.isExternal) {
                        <i class="fa-solid fa-square-arrow-up-right ml-auto external-icon"></i>
                      }
                    </a>
                  }
                  <!-- END SIMPLE BUTTON IF NO CHILDREN -->
                  <!-- PARENT BUTTON IF CHILDREN -->
                  @if (level0.children) {
                    <a pRipple
                      class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-colors no-text-decoration menu-link"
                      pStyleClass="@next" enterFromClass="hidden" enterActiveClass="slidedown" leaveToClass="hidden"
                      leaveActiveClass="slideup" [id]="level0.data.id ?? ''">
                      <i [class]="'sidebar-icon fa ' + level0.data.iconClass"></i>
                      <span class="font-medium">{{level0.label}}</span>
                      <i class="fa fa-solid fa-chevron-down ml-auto"></i>
                    </a>
                  }
                  <!-- END PARENT BUTTON IF CHILDREN -->
                  <ul
                    class="list-none py-0 pl-3 pr-0 m-0 mr-3 overflow-y-hidden animation-duration-500 transition-ease-in-out test-level1"
                    [ngClass]="routeIsInGroup(level0.data.initialRouteGroup) ? '' : 'hidden'">
                    <!-- LOOP OVER LEVEL 1 MENU BUTTONS -->
                    @for (level1 of level0.children; track level1) {
                      <li class="test-level1">
                        <!-- IF USER HAS PERMISSION FOR LEVEL 1 -->
                        @if (userService.hasPermissionIn(level1.data.hasPermissionIn)) {
                          <!-- SIMPLE BUTTON IF NO CHILDREN -->
                          @if (!level1.children) {
                            <a pRipple
                              class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors menu-link"
                              [routerLink]="level1.data.isExternal ? null : level1.data.routerLink"
                              [queryParams]="level1.data.isExternal ? null : (level1.data.queryParams || {})"
                              (click)="level1.data.isExternal ? openExternalLink(level1.data.externalLink) : null"
                              [ngClass]="(!level1.data.isExternal && currentUrlRoot.startsWith(level1.data.currentUrlRoot)) ? 'router-link-active' : ''"
                              [id]="level1.data.id ?? ''">
                              <span class="font-medium">{{level1.label}}</span>
                              @if (level1.data.isExternal) {
                                <i class="fa-solid fa-square-arrow-up-right ml-auto external-icon"></i>
                              }
                            </a>
                          }
                          <!-- END SIMPLE BUTTON IF NO CHILDREN -->
                          <!-- PARENT BUTTON IF CHILDREN -->
                          @if (level1.children && level1.children.length > 0) {
                            <a pRipple
                              class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors no-text-decoration menu-link"
                              pStyleClass="@next" enterFromClass="hidden" enterActiveClass="slidedown" leaveToClass="hidden"
                              leaveActiveClass="slideup">
                              <span class="font-medium">{{level1.label}}</span>
                              <i class="fa fa-solid fa-chevron-down ml-auto"></i>
                            </a>
                            <ul
                              class="list-none py-0 pl-3 pr-0 m-0 mr-3 overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out test-level2"
                              [ngClass]="routeIsInGroup(level1.data.initialRouteGroup) ? '' : 'hidden'">
                              <!-- LOOP OVER LEVEL 2 MENU BUTTONS -->
                              @for (level2 of level1.children; track level2) {
                                <li class="test-level2">
                                  @if (userService.hasPermissionIn(level2.data.hasPermissionIn)) {
                                    <!-- SIMPLE BUTTON IF NO CHILDREN -->
                                    @if (!level2.children) {
                                      <a pRipple
                                        class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors menu-link"
                                        [routerLink]="level2.data.isExternal ? null : level2.data.routerLink"
                                        [queryParams]="level2.data.isExternal ? null : (level2.data.queryParams || {})"
                                        (click)="level2.data.isExternal ? openExternalLink(level2.data.externalLink) : null"
                                        [ngClass]="(!level2.data.isExternal && currentUrlRoot.startsWith(level2.data.currentUrlRoot)) ? 'router-link-active' : ''">
                                        <span class="font-medium">{{level2.label}}</span>
                                        @if (level2.data.isExternal) {
                                          <i class="fa-solid fa-square-arrow-up-right ml-auto external-icon"></i>
                                        }
                                      </a>
                                    }
                                    <!-- END SIMPLE BUTTON IF NO CHILDREN -->
                                    <!-- PARENT BUTTON IF CHILDREN (LEVEL 3) -->
                                    @if (level2.children && level2.children.length > 0) {
                                      <a pRipple
                                        class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors no-text-decoration menu-link"
                                        pStyleClass="@next" enterFromClass="hidden" enterActiveClass="slidedown" leaveToClass="hidden"
                                        leaveActiveClass="slideup">
                                        <span class="font-medium">{{level2.label}}</span>
                                        <i class="fa fa-solid fa-chevron-down ml-auto"></i>
                                      </a>
                                      <ul
                                        class="list-none py-0 pl-3 pr-0 m-0 mr-3 overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out test-level3"
                                        [ngClass]="routeIsInGroup(level2.data.initialRouteGroup) ? '' : 'hidden'">
                                        <!-- LOOP OVER LEVEL 3 MENU BUTTONS -->
                                        @for (level3 of level2.children; track level3) {
                                          <li class="test-level3">
                                            @if (userService.hasPermissionIn(level3.data.hasPermissionIn)) {
                                              <a pRipple
                                                class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors menu-link"
                                                [routerLink]="level3.data.isExternal ? null : level3.data.routerLink"
                                                [queryParams]="level3.data.isExternal ? null : (level3.data.queryParams || {})"
                                                (click)="level3.data.isExternal ? openExternalLink(level3.data.externalLink) : null"
                                                [ngClass]="(!level3.data.isExternal && currentUrlRoot.startsWith(level3.data.currentUrlRoot)) ? 'router-link-active' : ''">
                                                <span class="font-medium">{{level3.label}}</span>
                                                @if (level3.data.isExternal) {
                                                  <i class="fa-solid fa-square-arrow-up-right ml-auto external-icon"></i>
                                                }
                                              </a>
                                            }
                                          </li>
                                        }
                                        <!-- END LOOP OVER LEVEL 3 MENU BUTTONS -->
                                      </ul>
                                    }
                                    <!-- END PARENT BUTTON IF CHILDREN (LEVEL 3) -->
                                  }
                                </li>
                              }
                              <!-- END LOOP OVER LEVEL 2 MENU BUTTONS -->
                            </ul>
                          }
                          <!-- END PARENT BUTTON IF CHILDREN -->
                        }
                        <!-- END IF USER HAS PERMISSION FOR LEVEL 1 -->
                      </li>
                    }
                    <!-- END LOOP OVER LEVEL 1 MENU BUTTONS -->
                  </ul>
                </li>
              </ul>
            }
            <!-- END IF USER HAS LEVEL 0 PERMISSION -->
          }
          <!-- END LOOP OVER LEVEL 0 MENU BUTTONS -->
        </div>

        <!-- add language switcher -->
        <div class="footer">
          <div class="centered flex justify-content-center language-switch-menu">
            <p-selectButton #languageSwitcher [options]="languageOptions" [ngModel]="locale" optionLabel="label"
              optionValue="value" (onChange)="onChangeLang($event)" [allowEmpty]="false"/>
            @if (user.email) {
              <p-button (onClick)="onClickLogout()" icon="fa fa-solid fa-arrow-right-from-bracket" styleClass="p-button-secondary logout" class="ml-3"/>
            }
          </div>
        </div>
      </div>
    </ng-template>
  </p-drawer>

  @if (!sidebarVisible) {
    <div class="hamburger-div">
      <a pRipple class="cursor-pointer inline-flex align-items-center justify-content-center"
        (click)="sidebarVisible = true">
        <i class="fa fa-solid fa-bars text-4xl"></i>
      </a>
    </div>
  }
  <!-- END SIDEBAR -->

  <div class="min-h-screen flex flex-column relative flex-auto">
    <!-- ROUTER OUTLET -->
    <div class="pt-0 pr-3 pl-3 flex flex-column router-outlet-container">
      <router-outlet/>
    </div>
    <!-- ROUTER OUTLET -->
  </div>
</div>

<div class="long-running-jobs-container">
  @for (job of longRunningJobs; track job) {
    <app-long-running-jobs-detail [job]="job"/>
  }
</div>

@if (appEnvironment !== 'production') {
  <div class='watermark'>TEST</div>
}

<p-toast #toast>
  <ng-template let-message #message>
    @if (message.icon) {
      <span [class]="'p-toast-message-icon pi ' + message.icon"></span>
    }
    @if (!message.icon) {
      <span class="p-toast-message-icon" [attr.aria-hidden]="true" [attr.data-pc-section]="'icon'">
        <ng-container>
          @if (message.severity === 'success') {
            <i class="pi pi-check text-green-500"></i>
          }
          @if (message.severity === 'info') {
            <i class="pi pi-info-circle text-blue-500"></i>
          }
          @if (message.severity === 'warn') {
            <i class="pi pi-exclamation-triangle text-orange-500"></i>
          }
          @if (message.severity === 'error') {
            <i class="pi pi-times-circle text-red-500"></i>
          }
        </ng-container>
      </span>
    }
    <div class="p-toast-message-text" [attr.data-pc-section]="'text'">
      <div class="p-toast-summary" [attr.data-pc-section]="'summary'">{{ message.summary }}</div>
      <div class="p-toast-detail" [attr.data-pc-section]="'detail'">{{ message.detail }}</div>
      @if (message.data?.html) {
        <div class="p-toast-html" [innerHTML]="message.data.html"></div>
      }
      @if (message.data?.button) {
        <div class="p-toast-button flex justify-content-end mt-3">
          <p-button size="small" [label]="message.data?.button.label"
            (onClick)="message.data?.button.callback(toast, message, $event)" />
        </div>
      }
    </div>
  </ng-template>
</p-toast>

<p-confirmDialog header="" icon="fa fa-solid fa-triangle-exclamation" [closable]="false"></p-confirmDialog>

<p-dialog header="Git!" [(visible)]="gitVersionsVisible" [style]="{width: '30vw'}">
  <h3>Front 🙃</h3>
  <div>
    <a [href]="'https://github.com/actedparis/acted-front/commit/' + theEnvironment.actedFrontCommitSha.slice(0, 7)" target="_blank" rel="noopener noreferrer">
      {{ theEnvironment.actedFrontCommitSha.slice(0, 7) }}
    </a>
  </div>
  <h3>Back 🙂</h3>
  <div>
    <a [href]="'https://github.com/actedparis/acted-ims/commit/' + theEnvironment.actedImsCommitSha.slice(0, 7)" target="_blank" rel="noopener noreferrer">
      {{ theEnvironment.actedImsCommitSha.slice(0, 7) }}
    </a>
  </div>
</p-dialog>

<app-tour uniqueKey="suppliers_welcome" panelTargetElementSelector="#suppliersMenu">
  @if (locale==='en') {
    Welcome to the suppliers database on CORE!<br/>
    <br/>
    This is the list view of the suppliers, you can view all their details by scrolling.<br/>
    <br/>
    Click on a supplier to access the detail view.
  }
  @if (locale==='fr') {
    Bienvenue dans la base de données fournisseurs de CORE !<br/>
    <br/>
    Il s’agit de la vue en liste contenant tous les fournisseurs, vous pouvez voir tous les détails en défilant.<br/>
    <br/>
    Cliquez sur un fournisseur pour accéder à sa vue détaillée.
  }
</app-tour>

<app-tour uniqueKey="compfu_welcome" panelTargetElementSelector="#crmMenu">
  @if (locale==='en') {
    Welcome to the COMPFU module on CORE!<br/>
    <br/>
    Here we can manage and view complaints from all ACTED’s missions.<br/>
    <br/>
    This is the list view containing all the complaints, you can view all their details by scrolling.
  }
  @if (locale==='fr') {
    Bienvenue dans le module COMPFU de CORE !<br/>
    <br/>
    Ici, nous pouvons gérer et visualiser les plaintes de toutes les missions d’ACTED.<br/>
    <br/>
    Il s’agit de la vue en liste contenant toutes les plaintes, vous pouvez voir tous les détails en défilant.
  }
</app-tour>

<app-tour uniqueKey="menu" panelTargetElementSelector="#homeMenu">
  @if (locale==='en') {
    The side menu leads you to the various modules you have access to.<br/>
    <br/>
    If you don’t see a module that you think you should have access to,<br/>
    ask your manager to give you access through the “Roles and access” menu.
  }
  @if (locale==='fr') {
    Le menu de navigation vous permet d’accéder au différents modules<br/>
    auxquels vous êtes autorisés.<br/>
    <br/>
    Si vous ne voyez pas un module dont vous devriez avoir accès,<br/>
    demandez à votre responsable de vous ajouter les permissions<br/>
    via le menu « Roles et accès ».
  }
</app-tour>
